import { render, staticRenderFns } from "./ListCoverLate.vue?vue&type=template&id=45f95364"
import script from "./ListCoverLate.vue?vue&type=script&lang=js"
export * from "./ListCoverLate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports